<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisi"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:40%;margin-left:5%;">
          <el-tree
        :data="osData"
        accordion
        :props="defaultProps"
        @node-click="chooseNode">
    </el-tree>
        </div>
 <span slot="footer" class="dialog-footer">
        <el-button @click="modification()">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "BillsDepartmenDialogone",
  data() {
    return {
    dialogVisi: false,
    title:"标题",
    labelPosition:'right',
      osData: [],
      AllDate:"",
      defaultProps: { children: 'children', label: 'officeName' },
      options:[],
      value1:"",
      array:[]
   
    };
  },
  methods: {
   chooseNode(data) {
      let obj = {
          "officeId":data.officeId,
          "officeName":data.officeName,
          "children":data.children,
      }
      if(obj.children.length >0){
  this.$message({
            type: "warning",
            message: "不能选择父节点("+obj.officeName+")请重新选择"
          })
      }else{
          this.$emit('AllData',obj)
      }
    },
    getUserOffice() {
   let obj = {
         "treeGroup":1,
          "officeType":"1",
          "grade":"1"
       }
      this.$http.post(this.$requestUrl.GET_USER_OFFICE_TREE,obj).then((res) => {
        let data = res.data.data;
          this.osData = data
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    modification(){
        this.dialogVisi = false
    }
  },
    mounted() {
    this.getUserOffice();
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
  },
}
</script>

<style scoped lang="scss">
.commonDialogBody {
    position: relative;
}
.commonDiaDiv{
    position:absolute;
    width:50%; 
    height: 500px;
    // border:1px solid;
    top: 90px;
    right: 45px;
}
</style>